import { render, staticRenderFns } from "./dict-add-or-update.vue?vue&type=template&id=02672f6f"
import script from "./dict-add-or-update.vue?vue&type=script&lang=js"
export * from "./dict-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./dict-add-or-update.vue?vue&type=style&index=0&id=02672f6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports